import script from "./MainFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainFooter.vue?vue&type=script&setup=true&lang=ts"

import "./MainFooter.vue?vue&type=style&index=0&id=bc5b1d68&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc5b1d68"]])

export default __exports__